module.exports = __webpack_public_path__ + "04_medium_black.0574a852.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/04_medium_black.png
// module id = oetc
// module chunks = 0